import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={44}
    height={44}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={44} height={44} rx={4.4} fill="#EBF2FF" />
    <Rect x={5} y={5} width={34} height={34} rx={4.25} fill="#FDFDFE" />
    <Path
      opacity={0.2}
      d="M24.4375 12.25V17.9375H30.125L24.4375 12.25Z"
      fill="#2D57D9"
    />
    <Path
      d="M29.3125 31.75H14.6875C14.472 31.75 14.2653 31.6644 14.113 31.512C13.9606 31.3597 13.875 31.153 13.875 30.9375V13.0625C13.875 12.847 13.9606 12.6403 14.113 12.488C14.2653 12.3356 14.472 12.25 14.6875 12.25H24.4375L30.125 17.9375V30.9375C30.125 31.153 30.0394 31.3597 29.887 31.512C29.7347 31.6644 29.528 31.75 29.3125 31.75Z"
      fill="#2D57D9"
      fillOpacity={0.1}
    />
    <Path
      d="M29.3125 31.75H14.6875C14.472 31.75 14.2653 31.6644 14.113 31.512C13.9606 31.3597 13.875 31.153 13.875 30.9375V13.0625C13.875 12.847 13.9606 12.6403 14.113 12.488C14.2653 12.3356 14.472 12.25 14.6875 12.25H24.4375L30.125 17.9375V30.9375C30.125 31.153 30.0394 31.3597 29.887 31.512C29.7347 31.6644 29.528 31.75 29.3125 31.75Z"
      stroke="#2D57D9"
      strokeWidth={1.625}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M24.4375 12.25V17.9375H30.125"
      stroke="#2D57D9"
      strokeWidth={1.625}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M18.75 22.8125H25.25"
      stroke="#2D57D9"
      strokeWidth={1.625}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M18.75 26.0625H25.25"
      stroke="#2D57D9"
      strokeWidth={1.625}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
export default SVGComponent;
